module.exports = __webpack_public_path__ + "4127b1a67be8bc9477c60fe9c8f738b1.woff2";